import { render } from "./PageTitle.vue?vue&type=template&id=ae8fb964&scoped=true&ts=true"
import script from "./PageTitle.vue?vue&type=script&lang=ts"
export * from "./PageTitle.vue?vue&type=script&lang=ts"

import "./PageTitle.vue?vue&type=style&index=0&id=ae8fb964&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae8fb964"]])

export default __exports__